module.exports = __webpack_public_path__ + "static/media/p004.8ea755aa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/p004.jpg
// module id = 1517
// module chunks = 0